module.exports = __webpack_public_path__ + "img/614615.22d91527.svg";